import React from 'react'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import Typography from 'LuxKit/Typography/Typography'
import { FilterPanelCheckItem } from './FilterPanelCheckboxGroup'
import Group from 'components/utils/Group'
import FormatCurrency from 'components/Common/FormatCurrency'
import { RENAMED_INCLUSIONS } from 'lib/search/constants'

interface Props {
  name: string;
  item: FilterPanelCheckItem;
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  titlecase?: boolean;
}

function FilterPanelCheckboxGroupItem(props: Props) {
  const {
    onChange,
    name,
    item,
    defaultChecked,
    checked,
    titlecase = false,
  } = props

  const displayLabel = RENAMED_INCLUSIONS[item.value] ?? item.label

  return (
    <CheckboxInput
      key={item.value}
      name={name}
      value={item.value}
      size="large"
      onChange={onChange}
      defaultChecked={defaultChecked}
      checked={item.checked ?? checked}
      hidden={item.hidden}
      data-carrier={item.value}
    >
      {item.price !== undefined && (
        <Group direction="horizontal" horizontalAlign="space-between" gap="0 4">
          {displayLabel}
          <span>
            <FormatCurrency
              value={item.price}
              format="roundedDollar"
            />
          </span>
        </Group>
      )}

      {item.price === undefined && (
        <Typography format={titlecase ? 'titlecase' : undefined} as="span">
          {displayLabel}
        </Typography>
      )}
    </CheckboxInput>
  )
}

export default FilterPanelCheckboxGroupItem
